export enum EServiceOperation {
  CUSTOM = 'custom',
  MEMBERSHIP = 'membership',
  OFF_STREET = 'off-street',
  ON_STREET = 'on-street',
}
